const padSeconds = (seconds: number) => (seconds < 10 ? `0${seconds}` : String(seconds));

export const formatTimestampDifference = (startTime: number, endTime?: number): string => {
  if (!endTime) {
    return '--:--';
  }

  const totalMilliseconds = endTime - startTime;

  if (Number.isNaN(totalMilliseconds) || totalMilliseconds < 0) {
    return '0 sec';
  }

  const totalSeconds = Math.floor(totalMilliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes > 0) {
    return `${minutes}:${padSeconds(seconds)} min`;
  }

  return `${seconds} sec`;
};
